const today = new Date()?.toISOString()?.split("T")[0];

export const DateInput = (props) => (
  <input type="date" max={today} {...props} />
);
